import { render, staticRenderFns } from "./CollapseTransition.vue?vue&type=template&id=1bb22a21&scoped=true&lang=html&"
import script from "./CollapseTransition.vue?vue&type=script&lang=js&"
export * from "./CollapseTransition.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTransition.vue?vue&type=style&index=0&id=1bb22a21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb22a21",
  null
  
)

export default component.exports